import Header from './components/Header';
import Hero from './components/Hero';
import Ranking from './components/Ranking';
import AppEntry from './components/AppEntry';
import Comments from './components/Comments';
import Topics from './components/Topics';
import Contact from './components/Contact';
import Cards from './components/Cards';
import About from './components/About';
import Media from './components/Media';
import Index from './components/Index';
import Features from './components/Features';
import Carousel from './components/Carousel';
import Faq from './components/Faq';
import Updates from './components/Updates';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Ranking />
        <AppEntry />
        <Comments />
        <Topics />
        <Contact />
        <Cards />
        <About />
        <Media />
        <Index />
        <Features />
        <Carousel />
        <Faq />
        <Updates />
      </main>
      <Footer />
    </div>
  );
}